var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7v2H7a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-4v-2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }